import React, { useState, useEffect } from 'react';

import { resetRadios } from '../../Utilities/General';

export const Invoice = (props) => {
  const [data, setData] = useState([]);
  const [disabledBtn, setDisabledBtn] = useState(true);
  const [step, setStep] = useState(props.step + 1); //siempre es el siguiente paso

  useEffect(() => {
    if (props.lastStep && props.visible === 'show') {
      resetRadios('InvoiceRadios');
      setDisabledBtn(true);
      //setStep(props.step + 1); //siempre es el siguiente paso
    }
  }, [props.step, props.lastStep, props.visible]);

  const clickRadio = (value, data) => {
    const selectItem = {
      invoice: {
        id: value,
        name: data,
      },
    };
    setData(selectItem);
    if (parseInt(value) === 2) {
      if (props.lastStep) {
        setStep(8); //Ultima pantalla
      } else {
        setStep(7); //Forma de pago
        props.setOrigen2(5);
      }
    } else {
      setStep(6);
      props.setOrigen2(6);
    }
    setDisabledBtn(false);
  };

  return (
    <div className={'card ' + props.visible}>
      <div className="card-header text-center">
        <h3>Factura</h3>
      </div>
      <div className="card-body">
        <div className="row mb-6">
          <div className="col-12">
            <h5 className="card-text card-title">¿Requiere factura?</h5>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-12">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="InvoiceRadios"
                id="Invoice1Radios"
                value="1"
                onClick={(e) => clickRadio(e.target.value, 'Si')}
              />
              <label className="form-check-label" htmlFor="Invoice1Radios">
                Si
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="InvoiceRadios"
                id="Invoice2Radios"
                value="2"
                onClick={(e) => clickRadio(e.target.value, 'No')}
              />
              <label className="form-check-label" htmlFor="Invoice2Radios">
                No
              </label>
            </div>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-6 text-end">
            <button
              type="button"
              className="btn btn-lg btn-outline-danger"
              disabled={disabledBtn}
              onClick={(e) => props.eventButton(true, step, data)}
            >
              Continuar
            </button>
          </div>
          <div className="col-6 text-start">
            <button
              type="button"
              className="btn btn-lg btn-outline-secondary"
              onClick={(e) => props.eventButton(true, props.originStep, data)}
            >
              Regresar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
